import React from 'react';
import CompoundCard from './CompoundCard';
import './SearchResults.css';

const SearchResults = ({ searchResults, onFavoriteCompound }) => {
  if (!searchResults || (!searchResults.results && !searchResults.message)) return null;

  const parseSearchResults = () => {
    if (typeof searchResults === 'string') {
      try {
        return JSON.parse(searchResults);
      } catch {
        return { message: searchResults };
      }
    }
    return searchResults;
  };

  const parsed = parseSearchResults();
  const results = parsed.results || [];

  // Count compounds the buyer can actually buy in, not compounds returned.
  // total_results counts area matches: the search matches on location before
  // budget or bedrooms, so "Found 5 matching properties" was shown for five
  // compounds holding zero affordable units between them. The same wrong
  // denominator was on the voice card and is fixed there too.
  const buyable = results.filter(
    (r) => (Array.isArray(r.matching_units) && r.matching_units.length > 0) || r.total_matching_units,
  );

  if (results.length === 0 && !parsed.message) return null;

  return (
    <div className="search-results">
      <h4 className="search-results-title">
        {buyable.length > 0
          ? `${buyable.length} compound${buyable.length === 1 ? '' : 's'} with units in your range`
          : `${results.length} compound${results.length === 1 ? '' : 's'} nearby`}
      </h4>
      {results.length > 0 && buyable.length === 0 && (
        // Said once, here, rather than left for the buyer to infer from cards
        // that each quietly say nothing.
        <p className="search-results-count">
          None have a unit matching your budget and rooms yet — worth a look anyway,
          or widen the search.
        </p>
      )}
      {results.length > 0 ? (
        <div className="search-results-grid">
          {results.map((item, index) => (
            <CompoundCard
              key={item.compound_id || item.project_name || index}
              compound={item}
              onFavorite={onFavoriteCompound}
            />
          ))}
        </div>
      ) : parsed.message ? (
        <div className="search-results-message">{parsed.message}</div>
      ) : null}
    </div>
  );
};

export default SearchResults;
